import React from 'react';
import { FormattedMessage } from 'react-intl';
import { IUploadThemeArchiveJobDetails, IUploadThemeArchiveJobResult } from '../../../api/jobs.dao';
import { IConcreteJobConfirmationPopupProperties, IJobResultComponentProps } from '../jobs-monitor-host.viewmodel';
import { AlertErrorMessage } from '../../global/modal/alerts-host/types/alert/alert-error-message';

const uploadThemeArchive: IConcreteJobConfirmationPopupProperties<IJobResultComponentProps<IUploadThemeArchiveJobDetails>> = {
    reviewFailedJobButtonText: 'Ok',
    reviewCompletedJobButtonText: 'Ok',
    completeComponent: () => {
        return <div className='alert-content'>
            <div className='alert-content__item'>Upload Complete</div>
        </div>;
    },
    failedComponent: (props: IJobResultComponentProps<IUploadThemeArchiveJobDetails, IUploadThemeArchiveJobResult>) => {
        return <AlertErrorMessage
            title={
                <FormattedMessage
                    defaultMessage='Upload Failed'
                    description='Label text'
                    id='oe.alerts.uploadFailed'
                />}
            message={props.result?.failureReason
                || <FormattedMessage
                    defaultMessage='Unknown failure reason'
                    description='Label text'
                    id='oe.alerts.unknownFailureReason'
                />
            }
        />;
    },
};

export { uploadThemeArchive };
